import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Navbar.css';

const Navbar = () => {
  const location = useLocation();
  const { user, logout, isAuthenticated } = useAuth();

  const sucursalLabel = user?.sucursal
    ? `${user.sucursal.charAt(0).toUpperCase()}${user.sucursal.slice(1)}`
    : '';

  const rolLabel = user?.rol === 'admin'
    ? 'Administrador'
    : user?.rol === 'fabrica'
      ? 'Fábrica'
      : 'Sucursal';

  const mobileBrandText = sucursalLabel ? `${rolLabel} ${sucursalLabel}` : rolLabel;
  
  // No mostrar navbar en login o si no está autenticado
  if (location.pathname === '/' || !isAuthenticated) {
    return null;
  }

  const menuItems = [
    { path: '/dashboard', label: 'Dashboard', icon: '📊' },
    { path: '/clientes', label: 'Clientes', icon: '👥' },
    { path: '/productos', label: 'Stock', icon: '📦' },
    { path: '/presupuestos', label: 'Presupuestos', icon: '💰' },
    { path: '/pedidos', label: 'Pedidos', icon: '🚚' },
    ...(user?.rol === 'admin' ? [{ path: '/panel-control', label: 'Panel de Control', icon: '⚙️' }] : [])
  ];

  const handleLogout = () => {
    logout();
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <Link to="/dashboard">
          <h2>
            <span className="brand-desktop">🏠 Mueblería</span>
            <span className="brand-mobile">🏠 {mobileBrandText}</span>
          </h2>
        </Link>
      </div>

      <div className="navbar-menu">
        {menuItems.map(item => (
          <Link
            key={item.path}
            to={item.path}
            className={`navbar-item ${location.pathname === item.path ? 'active' : ''}`}
          >
            <span className="icon">{item.icon}</span>
            <span className="label">{item.label}</span>
          </Link>
        ))}
      </div>

      <div className="navbar-user">
        <div className="user-info">
          <span>👤 {user?.nombre || 'Usuario'}</span>
          <span className="user-role">
            {user?.rol === 'admin' ? 'Administrador' : 
             user?.rol === 'fabrica' ? 'Fábrica' :
             user?.sucursal ? `Sucursal ${user.sucursal.charAt(0).toUpperCase() + user.sucursal.slice(1)}` : 
             'Usuario'}
          </span>
        </div>
        <button className="logout-btn" onClick={handleLogout}>
          🚪 Salir
        </button>
      </div>
    </nav>
  );
};

export default Navbar;